export const CONSENT_GATE_LIMIT = 20;

/**
 * Holds actions until consent is known, then runs them in order on a grant and
 * drops them on a denial. The consent provider reads the stored choice only after mount.
 */
export const createConsentGate = (limit = CONSENT_GATE_LIMIT) => {
	let state: "unknown" | "granted" | "denied" = "unknown";
	let pending: Array<() => void> = [];

	return {
		run(action: () => void) {
			if (state === "granted") {
				action();
			} else if (state === "unknown" && pending.length < limit) {
				pending.push(action);
			}
		},
		settle(granted: boolean) {
			state = granted ? "granted" : "denied";
			const queued = pending;
			pending = [];
			if (granted) queued.forEach((action) => action());
		},
	};
};
